import axios from 'axios';
import {responseHandler} from './responseHandler';
import {apiServiceUrl} from "./skeletonSaga";

export const skeletonGet = (action: string, endpoint: string): Promise<unknown> => {
    const token = localStorage.getItem('sessionToken');
    const headers = {"Authorization": `Bearer ${token}`};
    return axios
        .get(apiServiceUrl + endpoint + '/' + action, {headers})
        .then(responseHandler)
        .catch(function (error) {
            // if (error.code === SESSION_EXPIRED_NOT_FOUND) {
            //     throw {...error, type: CLIENT_IS_NOT_LOGGED_IN};
            // }
            throw error;
        });
};
